<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="ユーザID、名前、ふりがな、メイン所属、職種、役職、補足情報から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="careworkerFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="careworkers"
      :router="router"
      @import="importModal"
      @remove="remove"
      @exportFile="exportFile"
    >
    </controller>
    <div class="modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'
import * as XLSX from 'xlsx-js-style'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/careworkers/add',
      showloadingModal: false,
      showImportModal: false,
      excelData: null,
      confirmed: ''
    }
  },
  computed: {
    careworkers() {
      return this.$store.state.careworkers.careworkers
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedCareworkerList() {
      return this.$store.state.careworkers.selectedCareworkerList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      var selectedCareworkerList = this.selectedCareworkerList.map(
        (carewoker) => {
          let userId = carewoker.userId
          return {userId}
        }
      )
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'careworkers/deleteCareworkers',
          selectedCareworkerList
        )
        this.$store.dispatch('careworkers/clearSelectedCareworkerList')
        this.finishWord = '対象のユーザを削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/careworkers') {
          this.$router.push('/careworkers')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0050') {
            this.finishWord =
              this.errorMsg.MSGCRC0050.name +
              this.errorMsg.MSGCRC0050.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0050'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0050.name +
            this.errorMsg.MSGCRC0050.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    careworkerFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(data) {
      this.excelData = data
      this.showImportModal = true
    },
    async importFile() {
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      setTimeout(async () => {
        try {
          const excelDataList = this.loadExcelData(this.excelData)
          createList = createList.concat(excelDataList)
        } catch (error) {
          this.showloadingModal = false
          return
        }
        if (location.pathname !== '/careworkers') {
          this.$router.push('../careworkers')
        }
        try {
          await this.$store.dispatch('careworkers/importUsers', createList)
          this.$emit('list-reload')
          this.finishWord = 'インポートしました。'
          this.showFinishModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230009
          let eventType = 3
          let reason = ''
          if (error.response && error.response.data) {
            if (error.response.data.header) {
              let errorMessage = error.response.data.header.message.split(',')
              if (errorMessage[0] === 'MSGCRC0041') {
                this.finishWord =
                  this.errorMsg.MSGCRC0041.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0041.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0042') {
                this.finishWord =
                  this.errorMsg.MSGCRC0042.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0042.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0043') {
                this.finishWord =
                  this.errorMsg.MSGCRC0043.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0043.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0044') {
                this.finishWord =
                  this.errorMsg.MSGCRC0044.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0044.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0093') {
                this.finishWord =
                  this.errorMsg.MSGCRC0093.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0093.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0102') {
                this.finishWord =
                  this.errorMsg.MSGCRC0102.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0102.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0103') {
                this.finishWord =
                  this.errorMsg.MSGCRC0103.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0103.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0104') {
                this.finishWord =
                  this.errorMsg.MSGCRC0104.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0104.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0105') {
                this.finishWord =
                  this.errorMsg.MSGCRC0105.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0105.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0106') {
                this.finishWord =
                  this.errorMsg.MSGCRC0106.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0106.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0107') {
                this.finishWord =
                  this.errorMsg.MSGCRC0107.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0107.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0108') {
                this.finishWord =
                  this.errorMsg.MSGCRC0108.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0108.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0118') {
                this.finishWord =
                  this.errorMsg.MSGCRC0118.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0118.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0123') {
                this.finishWord =
                  this.errorMsg.MSGCRC0123.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0123.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0131') {
                this.finishWord =
                  this.errorMsg.MSGCRC0131.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0131.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0132') {
                this.finishWord =
                  this.errorMsg.MSGCRC0132.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0132.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0137') {
                this.finishWord =
                  this.errorMsg.MSGCRC0137.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0137.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0148') {
                this.finishWord =
                  this.errorMsg.MSGCRC0148.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0148.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0149') {
                this.finishWord =
                  this.errorMsg.MSGCRC0149.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0149.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0156') {
                this.finishWord =
                  this.errorMsg.MSGCRC0156.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0156.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0157') {
                this.finishWord =
                  this.errorMsg.MSGCRC0157.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0157.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0158') {
                this.finishWord =
                  this.errorMsg.MSGCRC0158.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0158.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0159') {
                this.finishWord =
                  this.errorMsg.MSGCRC0159.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0159.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0160') {
                this.finishWord =
                  this.errorMsg.MSGCRC0160.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0160.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0180') {
                this.finishWord =
                  this.errorMsg.MSGCRC0180.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0180.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0181') {
                this.finishWord =
                  this.errorMsg.MSGCRC0181.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0181.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0182') {
                this.finishWord =
                  this.errorMsg.MSGCRC0182.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0182.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0183') {
                this.finishWord =
                  this.errorMsg.MSGCRC0183.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0183.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0185') {
                this.finishWord =
                  this.errorMsg.MSGCRC0185.name +
                  (Number(errorMessage[1]) + 1) +
                  this.errorMsg.MSGCRC0185.beforeValue +
                  errorMessage[1] +
                  this.errorMsg.MSGCRC0185.afterValue +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0186') {
                this.finishWord =
                  this.errorMsg.MSGCRC0186.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0186.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0273') {
                this.finishWord =
                  this.errorMsg.MSGCRC0273.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0273.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0264') {
                this.finishWord =
                  this.errorMsg.MSGCRC0264.name +
                  this.errorMsg.MSGCRC0264.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else {
                this.finishWord =
                  this.errorMsg.MSGCRC0054.name +
                  this.errorMsg.MSGCRC0054.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              }
              reason = errorMessage[0] + ' '
              reason += error.response.status
            } else {
              var obj = error.response.data
              var stringName = Object.keys(obj)[0]
              if (stringName.endsWith('birthday')) {
                this.finishWord =
                  this.errorMsg.MSGCRC0144.name +
                  this.errorMsg.MSGCRC0144.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                reason = 'MSGCRC0144'
              } else {
                this.finishWord =
                  this.errorMsg.MSGCRC0054.name +
                  this.errorMsg.MSGCRC0054.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                reason = 'MSGCRC0054'
              }
            }
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.finishWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFinishModal = true
        }
        this.showloadingModal = false
      }, 100)
    },
    loadExcelData(excelData) {
      const createList = []
      let workbook
      let excelRows
      try {
        workbook = XLSX.read(excelData, {type: 'array'})
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        if (!worksheet) throw new Error('no worksheet')
        excelRows = XLSX.utils.sheet_to_json(worksheet, {
          defval: '',
          raw: false
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_510003
        let eventType = 9
        let reason = 'MSGCRC0314'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (e) {}
        this.finishWord =
          this.errorMsg.MSGCRC0314.name +
          this.errorMsg.MSGCRC0314.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFinishModal = true
        this.showloadingModal = false
        throw new Error()
      }
      if (excelRows.length === 0) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_510002
        let eventType = 9
        let reason = 'MSGCRC0010'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.finishWord =
          this.errorMsg.MSGCRC0010.name +
          this.errorMsg.MSGCRC0010.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFinishModal = true
        this.showloadingModal = false
        throw new Error()
      }
      for (let i = 0; i < excelRows.length; i++) {
        const row = excelRows[i]
        if (!row || Object.keys(row).length === 0) continue
        if (
          !this.$store.state.error.excelColumn.careworker.every(
            (key) => key in row
          )
        ) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230007
          let eventType = 9
          let reason = 'MSGCRC0008'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0008.name +
            this.errorMsg.MSGCRC0008.beforeValue +
            // キーの情報がない=ヘッダ情報がないとみなし、1に固定
            1 +
            this.errorMsg.MSGCRC0008.afterValue +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        let obj = {}
        obj['userId'] = row.ユーザID
        obj['familyName'] = row.姓
        obj['name'] = row.名
        obj['pronunciation'] = row.ふりがな
        obj['postCode'] = row.メイン所属コード
        obj['sub1PostCode'] = row.サブ１所属コード
        obj['sub2PostCode'] = row.サブ２所属コード
        obj['sub3PostCode'] = row.サブ３所属コード
        obj['sub4PostCode'] = row.サブ４所属コード
        obj['job'] = row.職種
        obj['position'] = row.役職
        const replaceBirthday = row.生年月日
        let pattern =
          /[0-9]{4}\/([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[12][0-9]|3[01])/
        if (
          !replaceBirthday.match(pattern) ||
          !this.isValidDate(replaceBirthday)
        ) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230009
          let eventType = 9
          let reason = 'MSGCRC0183'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0183.name +
            (i + 2) +
            '行目：' +
            this.errorMsg.MSGCRC0183.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        obj['birthday'] = `${replaceBirthday.replaceAll(
          '/',
          '-'
        )}T00:00:00.000Z`
        obj['memo'] = row.補足情報
        obj['fileRowCount'] = String(i + 2)
        obj['postId'] = ''
        obj['postName'] = ''
        obj['sub1PostId'] = ''
        obj['sub1PostName'] = ''
        obj['sub2PostId'] = ''
        obj['sub2PostName'] = ''
        obj['sub3PostId'] = ''
        obj['sub3PostName'] = ''
        obj['sub4PostId'] = ''
        obj['sub4PostName'] = ''
        createList.push(obj)
      }
      return createList
    },
    async exportFile(jobList) {
      let exportJobList = jobList.map((job) => {
        return {job: job.job}
      })
      var selectedCareworkerIdList = this.selectedCareworkerList.map((user) => {
        return {userId: user.userId}
      })
      this.showloadingModal = true
      try {
        const params = {
          userList: selectedCareworkerIdList,
          jobList: exportJobList
        }
        if (selectedCareworkerIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('careworkers/setExportData', params)

        const exportList = this.$store.state.careworkers.exportData
        let result = [this.$store.state.error.excelColumn.careworker]
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          let dateBirthday = new Date(exportList[i].birthday)
          let strBirthday =
            dateBirthday.getFullYear() +
            '/' +
            ('0' + (dateBirthday.getMonth() + 1)).substr(-2) +
            '/' +
            ('0' + dateBirthday.getDate()).substr(-2)
          result.push([
            exportList[i].userId,
            exportList[i].familyName,
            exportList[i].name,
            exportList[i].pronunciation,
            exportList[i].postCode,
            exportList[i].sub1PostCode,
            exportList[i].sub2PostCode,
            exportList[i].sub3PostCode,
            exportList[i].sub4PostCode,
            exportList[i].job,
            exportList[i].position,
            strBirthday,
            exportList[i].memo
          ])
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }

        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.aoa_to_sheet(result)

        const ref = worksheet['!ref']
        if (!ref) return
        const range = XLSX.utils.decode_range(ref)

        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({r: row, c: col})
            const cell = worksheet[cellAddress]
            if (!cell) continue
            // 文字列設定
            cell.t = 's'
            cell.z = '@'
          }
        }

        XLSX.utils.book_append_sheet(workbook, worksheet, 'ケアワーカー')
        const data = XLSX.write(workbook, {
          type: 'buffer',
          bookSST: true,
          bookType: 'xlsx',
          compression: true
        })

        let link = document.createElement('a')
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          window.navigator.msSaveOrOpenBlob(blob, 'ケアワーカー一覧.xlsx')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          link.setAttribute('download', 'ケアワーカー一覧.xlsx')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          link.setAttribute('download', 'ケアワーカー一覧.xlsx')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0055 '
          this.finishWord =
            this.errorMsg.MSGCRC0055.name +
            this.errorMsg.MSGCRC0055.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    isValidDate(dateString) {
      const [year, month, day] = dateString.split('/').map(Number)
      const date = new Date(year, month - 1, day)
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      )
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/controlbar.vue